module.exports = __webpack_public_path__ + "static/img/3.22c846d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/zh/3.png
// module id = 5g2R
// module chunks = 0